module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Shopping/MC-570ffe317da9f147de9c4674d71ae89b949f31a40c88957d955102b6622a5de1.svg";